import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import type { PropertyEditDialogsProps } from "../../../types/tabs";

export function PropertyEditDialogs({
  rentAmountConfirm,
  leaseLeadConfirm,
  resendInviteConfirm,
  resendInviteLoading,
  inviteExpiredConfirm,
  onClearRentAmountConfirm,
  onClearLeaseLeadConfirm,
  onResetLeaseStartAfterLeadWarning,
  onResendInvite,
  onClearResendInviteConfirm,
  onConfirmInviteExpired,
  onClearInviteExpiredConfirm,
}: PropertyEditDialogsProps) {
  return (
    <>
      <ConfirmDialog
        isOpen={rentAmountConfirm !== null}
        title="Rent Amount"
        message={`Please confirm the rent amount as ${rentAmountConfirm ?? ""}`}
        primaryLabel="Ok"
        secondaryLabel=""
        hideClose
        primaryFirst
        overlayDataTestId="application-property-tab-rent-amount-confirm"
        primaryButtonDataTestId="application-property-tab-rent-amount-confirm-ok-button"
        closeButtonDataTestId="application-property-tab-rent-amount-confirm-close"
        onPrimary={onClearRentAmountConfirm}
        onSecondary={onClearRentAmountConfirm}
        onDismiss={onClearRentAmountConfirm}
      />

      <ConfirmDialog
        isOpen={leaseLeadConfirm !== null}
        title="Companies Lead Time"
        message="Have you confirmed with the Community that the Lease Start Date will be honored for this date?"
        primaryLabel="Yes"
        secondaryLabel="No"
        overlayDataTestId="application-property-tab-lease-lead-confirm"
        primaryButtonDataTestId="application-property-tab-lease-lead-confirm-yes"
        secondaryButtonDataTestId="application-property-tab-lease-lead-confirm-no"
        closeButtonDataTestId="application-property-tab-lease-lead-confirm-close"
        onPrimary={onClearLeaseLeadConfirm}
        onSecondary={onResetLeaseStartAfterLeadWarning}
        onDismiss={onResetLeaseStartAfterLeadWarning}
      />

      <ConfirmDialog
        isOpen={resendInviteConfirm !== null}
        title="Resend Invite Code"
        message="Are you sure want to resend invite code?"
        primaryLabel={resendInviteLoading ? "Sending..." : "Yes"}
        secondaryLabel="No"
        primaryFirst
        overlayDataTestId="application-property-tab-resend-invite-confirm"
        primaryButtonDataTestId="application-property-tab-resend-invite-confirm-yes"
        secondaryButtonDataTestId="application-property-tab-resend-invite-confirm-no"
        closeButtonDataTestId="application-property-tab-resend-invite-confirm-close"
        onPrimary={onResendInvite}
        onSecondary={() => {
          if (!resendInviteLoading) onClearResendInviteConfirm();
        }}
        onDismiss={() => {
          if (!resendInviteLoading) onClearResendInviteConfirm();
        }}
      />

      <ConfirmDialog
        isOpen={inviteExpiredConfirm !== null}
        title="Invite Code Expired"
        message={`We found New matching Invite code ${inviteExpiredConfirm?.newCode ?? ""}, Use this invite code`}
        primaryLabel="Yes, Use This"
        secondaryLabel=""
        primaryFirst
        overlayDataTestId="application-property-tab-invite-expired-confirm"
        primaryButtonDataTestId="application-property-tab-invite-expired-confirm-yes"
        closeButtonDataTestId="application-property-tab-invite-expired-confirm-close"
        onPrimary={onConfirmInviteExpired}
        onSecondary={onClearInviteExpiredConfirm}
        onDismiss={onClearInviteExpiredConfirm}
      />
    </>
  );
}
